import React, { Component } from "react";
import Toast from 'react-bootstrap/Toast';
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import RestServiceStatic from "../services/rest.service";

export default class ShareTootNotification extends Component {

    constructor(props) {

        super(props);

        this.closeToast = this.closeToast.bind(this);
        this.editToot = this.editToot.bind(this);
        this.handleTootText = this.handleTootText.bind(this);
        this.tootThis = this.tootThis.bind(this);
        this.tootThisOnWeb = this.tootThisOnWeb.bind(this);

        this.state = {
            countChar: 0,
            show: true,
            sent: false,
            bodyStatus: ""
        }
    }

    render() {

        return (
            <div className="fixed-top toast-fmf-top">
                <div className="toast-fmf">
                    <Toast show={this.state.show} animation={true} className="custom-toast" onClose={this.closeToast}>
                        <Toast.Header>
                            <i className="bi bi-share"></i> &nbsp; &nbsp;
                            <strong className="me-auto">Share in Mastodon</strong>
                        </Toast.Header>
                        <Toast.Body>
                            {
                                this.state.bodyStatus === 'EDITING' 
                                ? 
                                <Form.Control as="textarea" size="sm" rows={4} onChange={this.handleTootText} defaultValue={"I've found " + this.props.number + " Mastodon friends in Pixelfed using"
                                    + " @findmyfriends@mastodon.social https://findmyfriends.online #pixelfed #mastodon"}/>
                                :
                                    this.state.bodyStatus === 'SENT'
                                    ?
                                    <div className="text-center">
                                        <i className="bi bi-check2-circle text-success"></i> <i>Toot was sent correctly.</i>
                                    </div>
                                    :
                                    <div onClick={() => this.editToot()}>
                                        I've found <strong>{this.props.number}</strong> Mastodon friends in Pixelfed using &nbsp;
                                        <i>@findmyfriends</i> https://findmyfriends.online <i>#pixelfed #mastodon</i>
                                        <br/><br/>
                                        <span className="text-muted toast-edit-text">Click here to edit the message before sending the toot</span>
                                    </div>
                            }
                            {this.state.countChar > 400 && this.state.countChar <= 449 ? <div className="mt-1 text-end"><span className="fs-8">{this.state.countChar + "/500"}</span></div> : ""}
                            {this.state.countChar > 449 && this.state.countChar <= 500 ? <div className="mt-1 text-end"><span className="fs-8 text-warning">{this.state.countChar + "/500"}</span></div> : ""}
                            {this.state.countChar > 500 ? <div className="mt-1 text-end"><span className="fs-8 text-danger">{this.state.countChar + "/500"}</span></div> : ""}
                            {this.state.bodyStatus !== 'SENT' ?
                                <div className="col-12 text-center mt-3">
                                    <Button size="sm" variant="primary" disabled={this.state.countChar > 500 || this.state.bodyStatus === 'SENT'}
                                        onClick={this.tootThis}>
                                        <i className="bi bi-mastodon"/> Toot this! 
                                    </Button>
                                </div>
                            :
                                "" 
                            }
                        </Toast.Body>
                    </Toast>
                </div>
            </div>
        );
    }

    editToot () {
        this.setState({
            bodyStatus: 'EDITING',
        });
    }

    closeToast () {
        this.setState({
            show: false,
        });
    }

    handleTootText({ target  }) {

        if (target && target.value && target.value.length) {
            this.setState({
                countChar: target.value.length,
                toot: target.value
            });
        }      
    }

    tootThis() {

        let mastodonInstance = localStorage.getItem('MastodonInstance');
        let mastodonToken = localStorage.getItem('MastodonToken');

        let toot = this.state.bodyStatus === 'EDITING' ? this.state.toot : "I've found " + this.props.number + " Mastodon friends in Pixelfed using"
        + " @findmyfriends@mastodon.social https://findmyfriends.online #pixelfed #mastodon";

        RestServiceStatic.toot(mastodonToken, mastodonInstance, toot).then(response => {

            if (response.data) {
                this.setState({
                    bodyStatus: 'SENT',
                });
                setTimeout(() => this.closeToast(), 1000);
            } else {
                this.tootThisOnWeb(toot, mastodonInstance)
            }

        }).catch(e => {
            this.tootThisOnWeb(toot, mastodonInstance)       
        });
        
    }

    tootThisOnWeb(toot, mastodonInstance) {

        let url = 'https://' + mastodonInstance + '/share?text=' + toot;

        window.open(url, '_blank', 'noreferrer');

        this.closeToast();
    }
}